var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const LG = "lg";
const LG_SMART_TV = "LG Smart Tv";
const WEBOS = "Web0S";
const LG_TIMED_TEXT = "LgTimedText";
function lgExtension(options = {}) {
  return (context) => __async(this, null, function* () {
    var _a;
    const { avia, logger, system } = context;
    const { KeyCode } = avia;
    if (!system.userAgent.includes(WEBOS)) {
      return;
    }
    avia.configure({
      system: {
        device: LG_SMART_TV,
        os: WEBOS,
        osVersion: "n/a",
        platform: avia.Platform.LINUX
      },
      keyboard: {
        map: {
          412: KeyCode.MEDIA_REWIND,
          413: KeyCode.MEDIA_STOP,
          415: KeyCode.MEDIA_PLAY,
          416: KeyCode.MEDIA_RECORD,
          417: KeyCode.MEDIA_FAST_FORWARD,
          460: KeyCode.MEDIA_CAPTIONS,
          461: KeyCode.ESCAPE
        }
      }
    });
    const useTimedTextPlugin = (options == null ? void 0 : options.useTimedTextPlugin) === false;
    if (useTimedTextPlugin) {
      avia.registerHook(avia.AviaHookType.CREATE_PLAYER, (context2) => {
        context2.value.plugins.push(timedTextPlugin());
      });
    }
    let { webOS } = system.global;
    if (!webOS) {
      yield avia.Util.loadScript(
        { url: ((_a = options == null ? void 0 : options.dependencies) == null ? void 0 : _a.url) || "https://avia.vtg.paramount.tech/avia-js/sandbox/lg/webOSTV.js" }
      );
      webOS = system.global.webOS;
    }
    if (!webOS) {
      logger.warn("LG TV Plugin unable to get device info.");
      return;
    }
    const deviceInfo = yield new Promise((resolve) => webOS.deviceInfo(resolve));
    logger.info("LG TV Plugin: Capabilities as JSON: " + JSON.stringify(deviceInfo));
    avia.registerHook(avia.AviaHookType.DEVICE_CAPABILITIES, avia.Util.cache("lgCapabilities", () => {
      return (context2) => {
        avia.Util.mapProperties(deviceInfo, context2.value, {
          dolbyAtmos: "supportsDolbyAtmos",
          dolbyVision: "supportsDolbyVision",
          hdr10: "supportsHdr10",
          uhd: "supportsUhd"
        });
      };
    }));
  });
  function createTimedTextPlugin(services) {
    const { player, avia } = services;
    player.on(avia.PlayerEvent.TEXT_CUEPOINT, (event) => {
      if (!player.isPlayingLive) {
        return;
      }
      const currentTime = event.target.video.currentTime;
      let refresh = false;
      event.detail.activeCues.forEach((cue) => {
        if (cue.endTime > currentTime) {
          return;
        }
        cue.track.removeCue(cue);
        refresh = true;
      });
      if (refresh) {
        player.textTrackEnabled = false;
        player.textTrackEnabled = true;
      }
    });
    return {
      getId() {
        return LG_TIMED_TEXT;
      },
      destroy() {
        player.off(avia.PlayerEvent.TEXT_CUEPOINT);
      }
    };
  }
  function timedTextPlugin() {
    return {
      id: LG_TIMED_TEXT,
      factory: createTimedTextPlugin
    };
  }
}
const ID = LG;
const extension = lgExtension;
export {
  ID,
  LG,
  LG_SMART_TV,
  LG_TIMED_TEXT,
  WEBOS,
  extension,
  lgExtension
};
//# sourceMappingURL=avia.lg.esm.js.map
